import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)
const store = {
  namespaced: true,
  state: () => ({
    CNPJForm: null,
    isEdit: false,
    showCNPJForm: false,
    nfModalData: {},
    // Lista desde o início: `NFflowTable` trata como array já no primeiro render.
    nfTableData: [],
    isPatientDisabled: false,
    providerModalSelected: {},
    isScheduledInvoice: false,
    loadingNfCompanies: false,
    companies: []
  }),
  mutations,
  getters,
  actions
}

export default store
